// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.liKBdX6yhM4NsRs2 {
    display: block;
    width: 100%;
    border: none;
    padding: 0;
    background-color: transparent;
    text-align: start;
}

.C8SL_iIK3d8ooRvi {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

.C8SL_iIK3d8ooRvi div {
    height: 100%;
    width: 100%;
    border-radius: var(--lok-spacing-1);
}
`, "",{"version":3,"sources":["webpack://./src/app/components/Tutorial/Tutorial.module.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,UAAU;IACV,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mCAAmC;AACvC","sourcesContent":[".triggerElement {\n    display: block;\n    width: 100%;\n    border: none;\n    padding: 0;\n    background-color: transparent;\n    text-align: start;\n}\n\n.triggerWrapper {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n}\n\n.triggerWrapper div {\n    height: 100%;\n    width: 100%;\n    border-radius: var(--lok-spacing-1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"triggerElement": `liKBdX6yhM4NsRs2`,
	"triggerWrapper": `C8SL_iIK3d8ooRvi`
};
export default ___CSS_LOADER_EXPORT___;
